module.exports = __webpack_public_path__ + "img/ZZRY_8.b1caeb93.jpg";